import React, { useEffect, useReducer } from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash';

import KenSelect from '../../../global_components/KenSelect';
import { intakeOptions, yearOptions } from '../AddActivity/data/data';
import { getAcademicFilter, getTermData } from '../../../Utils/apiServices';
import dayjs from '../../../Utils/dayjs';
import { useAppContext } from '../../../Utils/context';

const ACTIONS = {
  UPDATE_PROGRAMS: 'updatePrograms',
  UPDATE_PROGRAM: 'updateProgram',
  UPDATE_YEAR: 'updateYear',
  UPDATE_INTAKE: 'updateIntake',
  UPDATE_TERM_OPTIONS: 'updateTermOptions',
  UPDATE_TERM: 'updateTerm',
};
const initialState = {
  program: '',
  year: dayjs().format('YYYY'),
  intake: _.upperCase(dayjs().format('MMM')),
  term: '',
  termOptions: [],
  programs: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_PROGRAMS:
      const programs = _.map(
        action.value?.['Academic Program'],
        (value, prop) => ({ ...value, value: prop, label: prop })
      );

      return {
        ...state,
        programs,
        program: programs[0]?.value || '',
      };

    case ACTIONS.UPDATE_PROGRAM:
      // clear all dependent fields and other
      return {
        ...state,
        program: action.value,
        // year: '',
        // intake: '',
        term: '',
        termOptions: [],
      };

    case ACTIONS.UPDATE_YEAR:
      return {
        ...state,
        year: action.value,
      };
    case ACTIONS.UPDATE_INTAKE:
      return {
        ...state,
        intake: action.value,
      };

    case ACTIONS.UPDATE_TERM_OPTIONS:
      return {
        ...state,
        termOptions: action?.value
          // ?.filter((t) => t)
          .map((t) => ({
            ...t,
            value: t.TermRecordId,
            label: t.Semester,
          })),
      };
    case ACTIONS.UPDATE_TERM:
      return {
        ...state,
        term: action.value,
      };

    default:
      return state;
  }
};

const TermSelectionFilters = function (props) {
  console.log('SessionScheduler: TermSelectionFilters 1');
  const {
    initialValues = initialState,
    onProgramChange,
    onYearChange,
    onIntakeChange,
    onTermChange,
    onAcademicData,
  } = props;
  const [state, dispatch] = useReducer(reducer, initialValues);

  const {
    program,
    year,
    intake,
    term,
    programs = [],
    termOptions = [],
  } = state;

  const { handleSnackbarOpen } = useAppContext();
  useEffect(() => {
    // Get Academic data
    getAcademicFilter()
      .then((res) => {
        dispatch({ type: ACTIONS.UPDATE_PROGRAMS, value: res });
        onAcademicData(res);
      })
      .catch((err) => {
        console.log('TermSelctionFilter: getAcademicFilter: ', err);
      });
    // callback on success
  }, []);

  useEffect(() => {
    // get terms
    console.log('Get Term data');
    dispatch({ type: ACTIONS.UPDATE_TERM_OPTIONS, value: [] });
    if (program && year && intake) {
      getTermData({ program, intake, year })
        .then((res) => {
          if (res.length) {
            dispatch({ type: ACTIONS.UPDATE_TERM_OPTIONS, value: res });
            handleSnackbarOpen('success', 'Terms available. Please select');
          } else {
            handleSnackbarOpen(
              'error',
              'No terms available. Please change selection'
            );
          }
        })
        .catch((err) => {
          console.log('Term Data: ', err);
        });
    }
  }, [program, year, intake]);

  const handleProgram = ({ target: { value } }) => {
    // update program
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_PROGRAM, value });
      onProgramChange(value);
    }
  };

  const handleYear = ({ target: { value } }) => {
    // update year
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_YEAR, value });
      onYearChange(value);
    }
  };

  const handleIntake = ({ target: { value } }) => {
    // update intake
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_INTAKE, value });
      onIntakeChange(value);
    }
  };

  const handleTerm = ({ target: { value } }) => {
    // update term
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_TERM, value });
      onTermChange(value);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        <KenSelect
          name="program"
          label="Academic Program"
          options={programs}
          value={program}
          dropdownColor="#ffffff"
          onChange={handleProgram}
          required={true}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <KenSelect
          label="Year"
          name="year"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={handleYear}
          required={true}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <KenSelect
          name="intake"
          label="Intake"
          options={intakeOptions}
          value={intake}
          dropdownColor="#ffffff"
          onChange={handleIntake}
          required={true}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <KenSelect
          name="term"
          label="Term"
          options={termOptions}
          value={term}
          dropdownColor="#ffffff"
          onChange={handleTerm}
          required={true}
        />
      </Grid>
    </Grid>
  );
};

export default TermSelectionFilters;
